module.exports = __webpack_public_path__ + "static/media/outline-icons.701ae6ab.eot";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/outline-icons.eot
// module id = 407
// module chunks = 0